module.exports = __webpack_public_path__ + "static/media/mk.c1babcf5.webp";